import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.89 6.765-1.5 1.5a.375.375 0 0 1-.53 0l-.75-.75a.375.375 0 0 1 .53-.53l.485.485 1.235-1.235a.375.375 0 0 1 .53.53M6.75 7.891a3.188 3.188 0 1 0-3.37 0A5.6 5.6 0 0 0 .84 9.634a.375.375 0 0 0 .285.616H9a.375.375 0 0 0 .287-.616A5.6 5.6 0 0 0 6.75 7.89"
    }, null, -1)
  ]))]))
}
export default { render: render }